module.exports = __webpack_public_path__ + "img/dog-cat-blood.d9861fb2.png";